module.exports = "/_next/static/images/80d67f57f08fe437f3466a7e375467c9-oxxo-icon.svg";